import { render, staticRenderFns } from "./KitCreateDialog.vue?vue&type=template&id=1fd63f4a&scoped=true&"
import script from "./KitCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./KitCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd63f4a",
  null
  
)

export default component.exports